import Vue from 'vue';
import VueI18n from 'vue-i18n';
import fr from '../locales/fr.json';
import en from '../locales/en.json';

Vue.use(VueI18n);

let locale = localStorage.getItem('locale');

if (!locale || !['fr', 'en'].includes(locale)) {
    locale = navigator.language.includes('fr') ? 'fr' : 'en';
}

localStorage.setItem('locale', locale);
document.querySelector('html').setAttribute('lang', locale);

const i18n = new VueI18n({
    locale,
    fallbackLocale: 'fr',
    messages: {
        fr,
        en,
    },
});

// Hot Reloading
if (module.hot) {
    module.hot.accept(['../locales/fr', '../locales/en'], () => {
        i18n.setLocaleMessage('en', en);
        i18n.setLocaleMessage('fr', fr);
    });
}

export default i18n;
